export const START_RESERVATION_EXTENSION = 'START_RESERVATION_EXTENSION'
export const FAILED_RESERVATION_EXTENSION = 'FAILED_RESERVATION_EXTENSION'
export const EXTENSION_DATE_TIME_RANGE_SET = 'EXTENSION_DATE_TIME_RANGE_SET'
export const EXTEND_RESERVATION = 'EXTEND_RESERVATION'
export const EXTENDED_RESERVATION = 'EXTENDED_RESERVATION'
export const RESET_EXTENDING_PROGRESS = 'RESET_EXTENDING_PROGRESS'
